<template>
  <div class="desc-pic">
    <!--微信浏览器图片预览-->
    <div v-if="weixinShow" class="pic_img  clearfix">
      <div class="img_li" v-for="(item,index) in list" :key="index">
        <div class="img" v-lazy:background-image="item" @click="preview(index)"></div>
      </div>
    </div>
    <!--普通浏览器图片预览-->
    <!--img标签绑定图片的时候:src路径必须是url-->
    <div v-if="ordinaryShow" class="img-box" v-for="(url, index) in list"
         :style="{'background-image': 'url(' + url + ')'}"
         :key="index+'a'">
      <img preview="1" preview-text="" :src="url" alt="">
    </div>
  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'
  import {IsWeiXin} from '../../common/js/isWeixin'

  export default {
    data() {
      return {
        ordinaryShow: {
          type: Boolean // 普通浏览器
        },
        weixinShow: {
          type: Boolean // 微信浏览器
        }
      }
    },
    props: ['list'],
    created() {
      this.$previewRefresh()
      // 判断是否是微信浏览器
      if (IsWeiXin()) {
        this.ordinaryShow = false
        this.weixinShow = true
      } else {
        this.ordinaryShow = true
        this.weixinShow = false
      }
      // console.log(this.list)
    },
    methods: {
      preview(index) {
        wx.previewImage({
          current: this.list[index], // 当前显示图片的http链接
          urls: this.list // 需要预览的图片http链接列表
        })
      }
    }
  }
</script>

<style lang="scss">

  .desc-pic {
    padding: 10px;
    .desc {
      line-height: 16px;
      color: #292929;
    }
    .pic_img {
      width: 100%;
      .img_li {
        width: 24%;
        height: 80px;
        margin-top: 1%;
        float: left;
        margin-left: 1%;
        background: #f2f2f2;
        .img {
          width: 100%;
          height: 100%;
          background-size: cover;
        }
      }
    }
    .img-box {
      float: left;
      padding: 11%;
      margin: 1.5%;
      position: relative;
      overflow: hidden;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      img {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/desIdentPic.vue